// extracted by mini-css-extract-plugin
export default {"twoFactorForm":"TwoFactorForm_twoFactorForm__-N6J1","buttons":"TwoFactorForm_buttons__oCNsc"};